/**
 * External Dependencies.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

/**
 * Internal Dependencies.
 */
import routes from './routes';
import store from '../store';
import isStepCompleted from '../helpers/is-step-completed';

Vue.use(VueRouter);

const router = new VueRouter({
	routes,
	mode: 'hash',
	linkActiveClass: "active",
	linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);

    if (isStepCompleted(to, store)) {
		next()
	} else {
		next('/')
	}
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js